
export class ChangePasswordModel {
  email: string;
  oldPassword: string;
  newPassword: string;
}
